import script from "./profileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./profileView.vue?vue&type=script&setup=true&lang=ts"

import "./profileView.vue?vue&type=style&index=0&id=16c737c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c737c8"]])

export default __exports__